module.exports = __webpack_public_path__ + "static/img/file-txt.03c361cc.svg";